import { z } from 'zod'

/** 取得FFP_SSO網址資料 Schema */
export const ssoUrlDataSchema = z.object({
  url: z.string()
})

/** 取得FFP_SSO網址資料 */
export interface SsoUrlData extends z.infer<typeof ssoUrlDataSchema> {}
